/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { ICartItem_Product } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import {
  ICommonProductDetails,
  IProductDetails,
  ProductPreviewTypes,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useProductHasAttrs } from "@/hooks/product-has-attrs/useProductHasAttrs";
import { useIsMobile } from "@/hooks/useIsMobile";
import useProductPopup from "@/hooks/useProductPopup";
import { Col, Row } from "@/utils/bootstrap";
import { useEffect, useRef, useState } from "react";
import Price from "../../lib/Price";
import BreadCrumb from "../../lib/breadcrumb/BreadCrumb";
import { Link } from "../../lib/navigation/Link";
import AllCartItems from "../cart/all-cart-items/AllCartItems";
import AgreeTermsCheckbox from "../common/agree-terms/AgreeTermsCheckbox";
import SocialShareBtns, {
  ShareIconTypes,
} from "../common/social-share-btns/SocialShareBtns";
import Notes from "./details-belpers/Notes/Notes";
import ProductMainInfo from "./details-belpers/ProductMainInfo";
import SliderWithThumbs from "./details-belpers/SliderWithThumbs";
import Units from "./details-belpers/Units";
import DetailsSpec from "./details-belpers/details-specefications/DetailsSpec";
import AddOns from "./details-belpers/product-addons/AddOns";
import Attributes from "./details-belpers/product-attributes/Attributes";
import SpecificProduct from "./details-belpers/specific-product/SpecificProduct";
import { useForm } from "react-hook-form";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import {
  defaultValues,
  renameFields,
} from "../../common-form-builder/form-builder-helpers/form-functions";
import { TabbyPromo } from "../../lib/Tabby";
import useCanTabby from "@/hooks/useCanTabby";
import ProductDetailsPriceInfo from "./details-belpers/product-details-price-info/ProductDetailsPriceInfo";
import ProductOtherFields from "./details-belpers/ProductOtherFields";
import useRobosize from "@/hooks/useRobosize";
import { ReviewVisibility } from "@/api/AppApi/services/company/interfaces/ICompany";
import useCanTamara from "@/hooks/useCanTamara";
import TamaraPromo from "../../lib/Tamara/TamaraPromo";
import useSellingMode from "@/hooks/useSellingMode";
import EventDetails from "./Events/EventDetails";
import StockAlertMessage from "./details-belpers/StockAlertMessage";

interface Props {
  product: ICommonProductDetails;
  popup?: "normal" | "configrable" | false;
}

const ProductDetails: React.FC<Props> = ({ product, popup = false }) => {
  useRobosize({ product: product as IProductDetails });
  const form = useForm<any>();
  const [fields, setFields] = useState<Array<IField>>([]);
  const mobile = useIsMobile();
  const t = useTranslation();
  const { handleClosePopup } = useProductPopup();
  const getComapny = useGetCompanyQuery();
  const {
    show_specification_section,
    show_all_product_units,
    auto_select_first_child_in_show_product,
    show_low_stock_alert,
    min_stock_quantity_to_show_alert,
  } = getComapny?.data?.result?.theme?.components?.product ?? {};
  const prodState = useProductHasAttrs(product);
  const {
    currentProd,
    note,
    selectedAddOns,
    setSelectedChildIndex,
    handleNoteChange,
    handleSelectedAddOnsChanged,
    cartDisabled,
    otherInputs,
    selectedUnitId,
    selectedUnit,
    handleSelectUnits,
    getPrise,
    outOfStock,
    cartItemId,
    disablechangeAddon,
  } = prodState;
  const fieldsBuilder = (currentProd || product)?.fields_builder;
  const detailsCountainerRef = useRef<HTMLDivElement>(null);
  const [detailsCountaineMaxWidth, setdDtailsCountaineMaxWidth] = useState(0);
  const { data: cartData } = useGetCartQuery();
  const canTabby = useCanTabby();
  const canTamara = useCanTamara();
  const cart = cartData?.result;
  const configurableItems = cart?.items.filter((item) => {
    return (
      (item as ICartItem_Product).others.parent_id === currentProd.id ||
      (item as ICartItem_Product).others.parent_id === currentProd.parent_id
    );
  });
  const units = currentProd.units;
  const breadCrumb = <BreadCrumb hierarchy={[{ text: product?.name }]} />;
  const mClass = mobile ? "-mobile" : "";
  const ispopup = !!popup;
  const isConfigrablePopup = popup === "configrable";
  const isPopupMobile = mobile && ispopup;
  const showNoteField = !cartDisabled && Boolean(currentProd?.show_note_field);
  useEffect(() => {
    if (!prodState) return;
    const getKey = (str: string) => {
      const string = str.split(".");
      return string[string.length - 1];
    };
    const initFields = new Array<IField>();
    fieldsBuilder?.forEach((field) => {
      initFields?.push({
        ...field,
        value: otherInputs?.[getKey(field?.configurations?.key)],
      });
    });
    const fields = renameFields(initFields);
    form.reset(defaultValues(fields));
    setFields(fields!);
    setdDtailsCountaineMaxWidth(detailsCountainerRef?.current?.clientWidth!);
  }, [otherInputs, currentProd]);
  const termAndCondition = currentProd?.custom_data?.term_and_condition;
  const isService =
    currentProd.preview_type === ProductPreviewTypes.appointment ||
    currentProd.preview_type === ProductPreviewTypes.consultation;
  const [agree, setAgree] = useState(!(!!termAndCondition && !isService));

  const showMinStockQuantityMsg =
    show_low_stock_alert &&
    currentProd.quantity_on_hand <= min_stock_quantity_to_show_alert! &&
    !outOfStock;

  useEffect(() => {
    if (
      selectedUnit?.min_quantity_in_cart &&
      selectedUnit?.min_quantity_in_cart > 0
    )
      form.setValue("quantity", selectedUnit?.min_quantity_in_cart);
  }, [selectedUnitId]);

  const { enableAddToCart } = useSellingMode();
  const showRate =
    getComapny?.data?.result?.theme?.components?.product
      ?.product_reviews_visibility !== ReviewVisibility.none;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: isPopupMobile ? 0 : 24,
      }}
    >
      {!(mobile || popup) && breadCrumb}
      <Row
        className={`m-0 ${
          isPopupMobile ? "product-details-pop-up-mobile" : ""
        }`}
        style={{
          // gap: mobile ? 24 : 32,
          height: isPopupMobile ? "100%" : "auto",
        }}
      >
        {!isConfigrablePopup && (
          <Col
            className={`${mobile ? "p-0" : ""}`}
            lg={currentProd?.images?.length > 1 ? 5 : 4}
          >
            <div
              className={`${
                !popup ? "product-details-slider-container" + mClass : ""
              }`}
            >
              <SliderWithThumbs
                key={currentProd.id}
                productImages={currentProd?.images}
                id={currentProd?.id}
                isPC={!mobile}
                isSmall={ispopup}
                productName={currentProd?.name}
              />
            </div>
            {!mobile && <SocialShareBtns type={ShareIconTypes.product} />}
            {ispopup && (
              <div className={`see-details-link${isPopupMobile ? mClass : ""}`}>
                <Link
                  prefetch={false}
                  href={`/products/${product.slug}${
                    cartItemId ? `?cart_item_referer=${cartItemId}` : ""
                  }`}
                  onClick={handleClosePopup}
                >
                  {t.see_details}
                </Link>
              </div>
            )}
          </Col>
        )}
        <Col
          className={`${mobile ? "p-0 pt-3 " : ""}`}
          lg={
            mobile
              ? { span: true }
              : isConfigrablePopup
              ? 12
              : currentProd?.images?.length > 1
              ? 7
              : 8
          }
        >
          <div
            ref={detailsCountainerRef}
            className={`product-details-container${
              ispopup ? "-pop-up" : mClass
            }`}
            style={
              isPopupMobile || isConfigrablePopup
                ? {
                    maxWidth: "100%",
                    justifyContent: "space-between",
                  }
                : {}
            }
          >
            {mobile && !ispopup && breadCrumb}
            <ProductMainInfo
              showRate={!!showRate}
              product={currentProd}
              isConfigrablePopup={isConfigrablePopup}
              link={
                isConfigrablePopup && (
                  <div
                    className={`see-details-link${isPopupMobile ? mClass : ""}`}
                    style={{ paddingTop: 0, lineHeight: "inherit" }}
                  >
                    <Link
                      prefetch={false}
                      href={"/products/" + product.slug}
                      onClick={handleClosePopup}
                    >
                      {t.see_details}
                    </Link>
                  </div>
                )
              }
            />
            {currentProd.preview_type === ProductPreviewTypes.event && (
              <EventDetails
                {...currentProd.custom_data!}
                price={currentProd.price}
                price_without_discount={currentProd.price_without_discount}
                special_prices={currentProd.selling_prices}
                justifyContentStart
              />
            )}
            {enableAddToCart && (
              <Price
                gap={10}
                priceFirst
                price={{ value: getPrise("price"), className: "price" }}
                priceWithoutDiscount={{
                  value: getPrise("price_without_discount"),
                  className: "price-without-discount",
                }}
                roundPrice
              />
            )}
            {showMinStockQuantityMsg && (
              <StockAlertMessage
                minStockQuantity={currentProd.quantity_on_hand}
              />
            )}
            <div
              className="d-flex flex-column"
              style={{ maxWidth: 590, gap: 24 }}
            >
              {canTamara && <TamaraPromo price={getPrise("price")} />}
              {canTabby && (
                <TabbyPromo price={getPrise("price")} source="product" />
              )}
            </div>

            {product?.selling_prices?.length > 1 && (
              <ProductDetailsPriceInfo
                productSpecialPrice={product.selling_prices}
              />
            )}
            {product?.attributes_builder?.length > 0 && (
              <div id="attributes-selector">
                <Attributes
                  product={product}
                  setSelectedChildIndex={setSelectedChildIndex}
                  autoSelectFirstChild={
                    auto_select_first_child_in_show_product!
                  }
                  detailsCountaineMaxWidth={detailsCountaineMaxWidth}
                />
              </div>
            )}
            {!currentProd.is_configurable &&
              currentProd?.addons_builder?.length > 0 && (
                <AddOns
                  addOnBiulder={currentProd.addons_builder}
                  state={selectedAddOns}
                  setState={handleSelectedAddOnsChanged}
                  detailsCountaineMaxWidth={detailsCountaineMaxWidth}
                  disablechangeAddon={disablechangeAddon}
                  productId={currentProd.id}
                />
              )}
            {show_all_product_units && !outOfStock && (
              <Units
                units={units}
                selectedUnitId={selectedUnitId!}
                onSelect={handleSelectUnits}
              />
            )}
            {fields &&
              fields?.length > 0 &&
              product?.preview_type !== ProductPreviewTypes.consultation && (
                <ProductOtherFields fields={fields} form={form} />
              )}
            {showNoteField && (
              <Notes
                notes={note}
                setNotes={handleNoteChange}
                disabled={cartDisabled}
              />
            )}
            {termAndCondition && !isService && (
              <AgreeTermsCheckbox
                checked={agree}
                setChecked={setAgree}
                terms={termAndCondition}
              />
            )}
            {!isConfigrablePopup && mobile && (
              <SocialShareBtns type={ShareIconTypes.product} />
            )}
            <SpecificProduct
              form={form}
              agreeTerms={agree}
              productState={prodState}
              isPopupMobile={isPopupMobile}
              popup={popup}
            />
          </div>
        </Col>
      </Row>
      {!ispopup && show_specification_section && (
        <DetailsSpec
          html={currentProd?.long_description}
          spec={currentProd?.specifications}
          showRate={showRate}
          rate={product?.rate}
          ratings={product?.ratings}
          canReview={product?.can_review}
          productId={product?.parent_id ?? product?.id}
        />
      )}
      {isConfigrablePopup && (
        <AllCartItems cartItems={configurableItems as []} menu={true} />
      )}
    </div>
  );
};

export default ProductDetails;
